import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { FiArrowRight } from 'react-icons/fi'
import TallerCard from '../TalleresCard/TallerCard'
import Talleres from '../../../service/Talleres'

/**
 * Tres talleres reales para que una pantalla vacía no sea un callejón sin salida.
 * Si la consulta falla o no hay talleres, no muestra nada.
 */
export default function TalleresSugeridos({ titulo = 'Talleres que te pueden', destacado = 'interesar' }) {
    const [talleres, setTalleres] = useState(null)

    useEffect(() => {
        let vigente = true
        Talleres.List({ limit: 3 })
            .then(res => { if (vigente) setTalleres(res.talleres || []) })
            .catch(() => { if (vigente) setTalleres([]) })
        return () => { vigente = false }
    }, [])

    if (talleres && talleres.length === 0) return null

    return (
        <section className="mt-12">
            <div className="flex items-end justify-between gap-4 mb-5">
                <h2 className="text-xl sm:text-2xl font-extrabold text-gray-900">
                    {titulo} <span className="hl-amarillo">{destacado}</span>
                </h2>
                <Link to="/#talleres-section"
                    className="flex-shrink-0 inline-flex items-center gap-1.5 text-sm font-bold text-primary hover:gap-2.5 transition-all">
                    Ver todos <FiArrowRight size={15} />
                </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {talleres
                    ? talleres.map(t => <TallerCard key={t._id} taller={t} />)
                    : [0, 1, 2].map(i => (
                        <div key={i} className="rounded-2xl bg-white overflow-hidden animate-pulse">
                            <div className="h-44 bg-gray-200" />
                            <div className="p-4 space-y-3">
                                <div className="h-4 bg-gray-200 rounded-full w-3/4" />
                                <div className="h-3 bg-gray-100 rounded-full w-1/2" />
                                <div className="h-8 bg-gray-200 rounded-xl mt-2" />
                            </div>
                        </div>
                    ))}
            </div>
        </section>
    )
}
